









import { Component, Prop, Vue } from 'vue-property-decorator'
import { Pipeline } from '@/api/model/pipeline'
import { namespace } from 'vuex-class'
const referrals = namespace('referrals')

@Component
export default class PipelineLabel extends Vue {
    @referrals.Getter('selectablePipelines') readonly pipelines!: Pipeline[]
    @Prop({ required: true }) readonly pipeline!: Pipeline

    getPipeline(id: string): Pipeline {
        return this.pipelines.find(v => v.id === id)
    }

    isExternalPipeline(id: string): boolean {
        return this.getPipeline(id).isExternal(this.$currentCompany)
    }
}
